import { render, staticRenderFns } from "./addTransferClassHour.vue?vue&type=template&id=1b8b051b&scoped=true&"
import script from "./addTransferClassHour.vue?vue&type=script&lang=js&"
export * from "./addTransferClassHour.vue?vue&type=script&lang=js&"
import style0 from "./addTransferClassHour.vue?vue&type=style&index=0&id=1b8b051b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8b051b",
  null
  
)

export default component.exports